import BaseSelect from "component/select/BaseSelect";
import { useQuizHook } from "hooks/content/useQuizHook";
import { useEffect } from "react";

/**
 * Form Input Web Address Props
 * 
 * @param {BaseContentFormProps & {
 *  id: string
 * }} props
 */
export default function FormInputQuiz({ 
  value, 
  setValue, 
  isInvalid, 
  isRequired, 
  errorMessage,
  isInitSelectedValueFromFormSelect,
  id,
}) {
  const { data, handler, } = useQuizHook()

  /**
   * Set Init Select Value
   * 
   * @param {Array<BaseSelectFormatData>} listOptions 
   */
  const setInitSelectValue = (listOptions) => {
    if (isInitSelectedValueFromFormSelect && Array.isArray(listOptions) && listOptions.length) {
      const isValueExist = listOptions.find(opt => opt.value === id)

      if (isValueExist) {
        setValue(isValueExist)
      }
    }
  }

  useEffect(() => {
    handler.getQuizHandler({ setInitSelectValue })
  }, [])

  return (
    <div className="form-group mb-5 row">
      <label className="col-sm-3 col-form-label" htmlFor='inputQuiz'>
        <span className="mr-1">Quiz</span>
        {isRequired
        ?
          <span className="text-danger">*</span>
        : null }
      </label>
      <div className="row col-sm-9">
        <div className="col-sm-8">
          <BaseSelect
            isSearchable={true}
            isMulti={false}
            onMenuOpen={handler.getQuizHandler}
            placeholder="Pilih Quiz"
            noOptionsMessage={() => 'Data quiz tidak dtemukan'}
            isClearable={true}
            options={data.listQuiz.optionsFilter}
            value={value}
            onChange={setValue}
          />

          {isInvalid ? (
            <label className="small form-text text-danger">
              {errorMessage || 'Quiz tidak boleh kosong.'}
            </label>
          ) : null}
        </div>

        <div className="col-sm-4">
          <button
            type="button"
            className="btn btn-primary btn-sm mt-2 mt-md-1"
            onClick={handler.popUpWindowKelolaQuizHandler}
          >
            <i className="feather icon-settings mr-1" />
            <span>Kelola Quiz</span>
          </button>
        </div>
      </div>
    </div>
  )
}